<template>
  <div>
    <PCNavbar selectIndex=""/>
    <MobileNavBar/>
    <Shopping/>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import Shopping from '@/components/shopping/index.vue'
import CallMe from '@/components/callme/index'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    Shopping,
    CallMe,
  },
}
</script>

<style>
</style>